import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';
import { getTabs } from '../constants/pages';

const TopTabs = ({ activeTab = 'patterns', onSelect }) => {
	const TABS = getTabs();

	if (typeof onSelect !== 'function') return null;

	return (
		<div className="vayu-top-tabs">
			{TABS.map((tab) => (
				<button
					key={tab.key}
					type="button"
					onClick={() => onSelect(tab.key)}
					className={`vayu-tab-btn ${activeTab === tab.key ? 'vb-btn-ds-is-active' : ''}`}
					aria-pressed={activeTab === tab.key}
				>
					{tab.label}
				</button>
			))}
		</div>
	);
};

TopTabs.propTypes = {
	activeTab: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
};

export default TopTabs;
